import ChipGroup from "common/core-ui/ChipGroup";
import { FormattedMessage } from "react-intl";
import styles from "./SampleFilter.module.scss";
import { useProgramName } from "routes/home/common/useProgramName.ts";

export type FilterValue =
  | "available_to_sample"
  | "coach_me_included"
  | "total_access"
  | "accessibility_claims";

interface SampleFiltersProps {
  value: FilterValue[];
  onChange: (filters: FilterValue[]) => void;
  onClear?: () => void;
  isActionBlocked?: boolean;
  programName?: string | null;
}

export default function SampleFilters({
  value,
  onChange,
  onClear,
  isActionBlocked = false,
  programName,
}: SampleFiltersProps) {
  const filterOptions: { value: FilterValue; label: React.ReactNode }[] = [
    {
      value: "available_to_sample",
      label: <FormattedMessage defaultMessage="Free eBook Sample" />,
    },
    {
      value: "coach_me_included",
      label: <FormattedMessage defaultMessage="CoachMe Included" />,
    },
    {
      value: "total_access",
      label: useProgramName(programName, true),
    },
    {
      value: "accessibility_claims",
      label: <FormattedMessage defaultMessage="Accessibility Claims" />,
    },
  ];

  const handleChange = (filters: FilterValue[]) => {
    if (isActionBlocked) {
      return;
    }
    onChange(filters);
  };

  const handleClear = () => {
    if (isActionBlocked) {
      return;
    }
    onClear?.();
  };

  return (
    <div className={styles.filterContainer}>
      <span className={styles.filterLabel} aria-hidden="true">
        <FormattedMessage defaultMessage="Filter by:" />
      </span>
      <ChipGroup<FilterValue>
        type="multi"
        name="sampleFilters"
        legend={<FormattedMessage defaultMessage="Filter by:" />}
        clearButtonPosition="end"
        value={value}
        onChange={handleChange}
        onClear={handleClear}
        options={filterOptions}
      />
    </div>
  );
}
